<template>
  <v-dialog :value="isOpen" persistent scrollable :width="500">
    <v-card>
      <v-card-title :style="{ flexWrap: 'nowrap' }">
        <div class="form-control grow">
          <input v-model="search" type="text" :placeholder="$t('Search')" class="ma-0" />
        </div>
        <v-btn icon flat left @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="isSelectAll"
          color="primary"
          :label="$t('Select all')"
          :indeterminate="isIndeterminateSelectAll"
          class="ma-0"
        />
        <v-list dense :style="{ margin: '0 -16px' }">
          <v-list-tile v-for="user in filteredUsers" :key="user.adminid" @click="() => {}">
            <v-list-tile-action>
              <v-checkbox
                :input-value="selectedUsers[user.adminid]"
                color="primary"
                @change="setSelectedUsers(user.adminid, $event || false)"
              />
            </v-list-tile-action>
            <v-list-tile-content
              @click="setSelectedUsers(user.adminid, !selectedUsers[user.adminid])"
            >
              <v-list-tile-title>{{ user.adminid }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <v-card-actions :style="{ justifyContent: 'center' }">
        <v-btn outline color="grey" @click="close()">{{ $t('cancel') }}</v-btn>
        <v-btn
          depressed
          color="primary"
          :disabled="!isSubmissible"
          :loading="isLoading"
          @click="submit()"
          >{{ $t('submit') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3CheckinApi from '@/api/ticket3/checkin'

export default {
  props: {
    users: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
      search: '',
      selectedUsers: {},
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filteredUsers() {
      if (!this.search) {
        return this.users
      }

      return this.users.filter((user) =>
        user.adminid.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    isSelectAll: {
      get() {
        return (
          Object.values(this.selectedUsers).filter((value) => value).length === this.users.length
        )
      },
      set(value) {
        if (!value) {
          this.selectedUsers = {}
          return
        }

        this.selectedUsers = this.users.reduce((prev, { adminid }) => {
          prev[adminid] = true
          return prev
        }, {})
      }
    },
    isIndeterminateSelectAll() {
      const length = Object.values(this.selectedUsers).filter((value) => value).length
      return length > 0 && length < this.users.length
    },
    isSubmissible() {
      return Object.values(this.selectedUsers).some((value) => value)
    }
  },
  mounted() {
    this.isOpen = true
  },
  methods: {
    close() {
      this.isOpen = false

      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },
    setSelectedUsers(id, value) {
      this.selectedUsers = { ...this.selectedUsers, [id]: value }
    },
    async submit() {
      this.isLoading = true

      try {
        const response = await ticket3CheckinApi.postForceCheckout({
          data: {
            page_id: this.selectedBot.pageid,
            admin_id_list: Object.keys(this.selectedUsers).filter((key) => this.selectedUsers[key])
          }
        })

        if (response.status === 200) {
          this.$emit('success')
          this.close()
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/user/LogoutDialog.vue